export const Logo = ({ size = 30, className = "", wordmark = true, dark = false }) => {
  const frameSize = Math.round(size * 1.22);
  return (
    <span className={`inline-flex items-center gap-2.5 ${className} ${dark ? "logo-on-dark" : ""}`} data-testid="doclyx-logo">
      <span
        className="logo-icon-frame"
        data-testid="doclyx-logo-frame"
        style={{ width: frameSize, height: frameSize, borderRadius: Math.max(8, Math.round(size * 0.24)) }}
      >
        <img
          src="/doclyx-icon-192.png"
          width={size}
          height={size}
          alt="Doclyx DX logo"
          className="logo-icon-img logo-mark-light shrink-0 select-none"
          data-testid="doclyx-logo-image"
          draggable={false}
        />
        <img
          src="/doclyx-dx-mark-dark.png"
          width={size}
          height={size}
          alt=""
          aria-hidden="true"
          className="logo-icon-img logo-mark-dark shrink-0 select-none"
          draggable={false}
        />
      </span>
      {wordmark && (
        <span className="font-sans font-medium tracking-tight text-lg text-ink">Doclyx</span>
      )}
    </span>
  );
};

export const LoadingMark = ({ label = "Loading workspace" }) => (
  <div className="flex flex-col items-center gap-4" data-testid="loading-mark">
    <Logo wordmark={false} size={54} />
    <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-mist">{label}</span>
  </div>
);
